import { render, staticRenderFns } from "./DetalhesCotacaoPropostaTab.vue?vue&type=template&id=6f898b50&scoped=true"
import script from "./DetalhesCotacaoPropostaTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesCotacaoPropostaTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DetalhesCotacaoPropostaTab.vue?vue&type=style&index=0&id=6f898b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f898b50",
  null
  
)

export default component.exports